// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"246":"landing","680":"form","712":"form1","756":"thanks","757":"game","884":"explain"}[chunkId] + "." + __webpack_require__.h() + ".js";
};